import React from "react";
import EntityForm from "../../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../../Common/utils";

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });
  const minRelease = {
    days: entity?.minRelease?.duration !== (undefined || null) ? entity?.minRelease?.duration : undefined,
    hours: entity?.minReleaseTimeLimit?.timeLimit || "23:59",
    timeZone: entity?.minReleaseTimeLimit?.timeZone || "Europe/Madrid",
  };
  const maxRelease = {
    days:
      entity?.maxRelease?.duration !== (undefined || null)
        ? entity?.maxRelease?.duration
        : undefined,
    hours: entity?.maxReleaseTimeLimit?.timeLimit || "23:59",
    timeZone: entity?.maxReleaseTimeLimit?.timeZone || "Europe/Madrid",
  };

  return {
    ...formValues,
    minRelease,
    maxRelease,
  };
}

class CancellationPolicyConfigurationForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit = ({ formValues }) => {
    const { id, ...otherFormValues } = formValues;

    const entity = otherFormValues;

    if (id !== "" && id !== " " && id !== null && typeof formValues.id !== "undefined") {
      entity.id = formValues.id;
    }
    entity.minReleaseTimeLimit =
      entity?.minRelease?.days === "undefined"
        ? null
        : {
            timeLimit: entity?.minRelease?.hours,
            timeZone: entity?.minRelease?.timeZone,
          };
    entity.minRelease =
      entity?.minRelease?.days === "undefined"
        ? null
        : {
            duration: entity?.minRelease?.days,
            chronoUnit: "DAYS",
          };
    entity.maxReleaseTimeLimit =
      entity?.maxRelease?.days === "undefined"
        ? null
        : {
            timeLimit: entity?.maxRelease?.hours,
            timeZone: entity?.maxRelease?.timeZone,
          };
    entity.maxRelease =
      entity?.maxRelease?.days === "undefined"
        ? null
        : {
            duration: entity?.maxRelease?.days,
            chronoUnit: "DAYS",
          };
    this.props.onSubmitEntity({
      entity,
    });
  };

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, translation, entities } = config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      nested,
      afterSubmit,
      onCancelEdit,
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        getListPath={getListPath}
        nested={nested}
        afterSubmit={afterSubmit}
        onCancelEdit={onCancelEdit}
        entityToFormValuesMapper={customEntityToFormValuesMapper}
      />
    );
  }
}

CancellationPolicyConfigurationForm.propTypes = {};

CancellationPolicyConfigurationForm.defaultProps = {
  locales: ["es", "en"],
  entity: {
    id: "wcbuUYGde3vSfcV2YkKwtf",
    ticker: "born_apt",
    pattern: "cb_born_apt",
    type: "ESTABLISHMENT",
    filterOptionPosition: 6,
    active: true,
    filterOptionTranslations: [
      {
        id: "r4qFUERDcJEXzs1Dg45WU7",
        locale: "it",
        name: "Apt | Born apt - Long stay",
        description: "Apt | Born apt - Long stay",
      },
      {
        id: "8G4nM8jjFCsquzTUgAd4Vx",
        locale: "pt",
        name: "Apt | Born apt - Long stay",
        description: "Apt | Born apt - Long stay",
      },
      {
        id: "7ZywTwBNndK2J8MGjcoMqe",
        locale: "en",
        name: "Apt | Born apt - Long stay",
        description: "Apt | Born apt - Long stay",
      },
      {
        id: "uJnYdBnYMdNkfXKHMjXNv9",
        locale: "fr",
        name: "Apt | Born apt - Long stay",
        description: "Apt | Born apt - Long stay",
      },
      {
        id: "thYn1ZNFfvqUf7Tjb2kVQS",
        locale: "es",
        name: "Apt | Born apt  - Larga estancia",
        description: "Apt | Born apt  - Larga estancia",
      },
      {
        id: "h7wTXaJqHvfFuppTEujie8",
        locale: "de",
        name: "Apt | Born apt - Long stay",
        description: "Apt | Born apt - Langzeitvermietung",
      },
      {
        id: "vYKSYQs84KDXhTz3mjM9GQ",
        locale: "ru",
        name: "Apt | Born apt - Long stay",
        description: "Apt | Born apt - Long stay",
      },
      {
        id: "8inPj7TX63wg7W1demgUXc",
        locale: "ca",
        name: "Apt | Born apt - Llarga estada",
        description: "Apartaments Born",
      },
    ],
  },
};

export default CancellationPolicyConfigurationForm;
